import { getTableItems } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/table';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import type { OwnProps, StateProps } from './types';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State, { itemIndex }: OwnProps): StateProps => ({
	item: getTableItems(state)[itemIndex],
});
